import type { MarketReportSubscriptionAttributes } from 'common'

import { coreClient } from './coreclient'

export default {
  async list() {
    const client = await coreClient()
    return client.marketReport
      .list()
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return [] as MarketReportSubscriptionAttributes[]
      })
  },
  async get(id: number) {
    const client = await coreClient()
    return client.marketReport
      .get(id)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async update(body: MarketReportSubscriptionAttributes) {
    const client = await coreClient()
    return client.marketReport
      .update(body)
      .then((response) => {
        if (response.data) {
          return response.data
        }
        return null
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  },
  async delete(id: number) {
    const client = await coreClient()
    return client.marketReport
      .delete(id)
      .then((response) => {
        return response.data
      })
      .catch((e) => {
        console.error(e)
        return false
      })
  }
}
